export const clientInfoReset = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
}
